import {MaterialSymbolRestDto} from "@/api/pharma-cms-content-block/models";
import {SymbolFamilyEnum} from "@/api/enums/symbol-family-enum";
import {SymbolWeightEnum} from "@/api/enums/symbol-weight-enum";
import {SymbolGradeEnum} from "@/api/enums/symbol-grade-enum";
import {SymbolOpticalSizeEnum} from "@/api/enums/symbol-optical-size-enum";

import {ColorRestDtoModel} from "@/models/api/ColorRestDtoModel";
import {ColorRestDto} from "@/api/pharma-cms-content-page/models";

export class MaterialSymbolRestDtoModel implements MaterialSymbolRestDto {
    family_code: SymbolFamilyEnum;
    name_code: string;
    size_in_rem: number;
    default_state_color: ColorRestDto;
    hover_state_color: ColorRestDto;
    is_filled?: boolean | null;
    weight_code: SymbolWeightEnum;
    grade_code: SymbolGradeEnum;
    optical_size_code: SymbolOpticalSizeEnum;

    constructor(
        family_code: SymbolFamilyEnum,
        name_code: string,
        size_in_rem: number,
        default_state_color: ColorRestDto,
        hover_state_color: ColorRestDto,
        weight_code: SymbolWeightEnum,
        grade_code: SymbolGradeEnum,
        optical_size_code: SymbolOpticalSizeEnum
    ) {
        this.family_code = family_code;
        this.name_code = name_code;
        this.size_in_rem = size_in_rem;
        this.default_state_color = default_state_color;
        this.hover_state_color = hover_state_color;
        this.weight_code = weight_code;
        this.grade_code = grade_code;
        this.optical_size_code = optical_size_code;
    }

    public static createWithDefaults(): MaterialSymbolRestDtoModel {
        const model: MaterialSymbolRestDtoModel = new this(
            SymbolFamilyEnum.MATERIAL_SYMBOLS_OUTLINED,
            'settings',
            2,
            ColorRestDtoModel.createWithDefaults(),
            ColorRestDtoModel.createWithDefaults(),
            SymbolWeightEnum.FW_400,
            SymbolGradeEnum.GRADE_200,
            SymbolOpticalSizeEnum.OPTSZ_48,
        );
        model.is_filled = false;

        return model;
    }

    public static cloneFrom(source: MaterialSymbolRestDto): MaterialSymbolRestDtoModel {
        const clone: MaterialSymbolRestDtoModel = new this(
            source.family_code,
            source.name_code,
            source.size_in_rem,
            ColorRestDtoModel.cloneFrom(source.default_state_color),
            ColorRestDtoModel.cloneFrom(source.hover_state_color),
            source.weight_code,
            source.grade_code,
            source.optical_size_code
        );
        clone.is_filled = source.is_filled;

        return clone;
    }
}
